import React from 'react';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';

import { Format } from '@/domain/app';
import { GooglePayTeData } from '@/domain/digital-wallet';

import { DigitalWalletSignResponse } from '@generated-types';
import useText from '@hooks/use-text';

import PermissionSigning from './permission-signing/PermissionSigning';
import PushProvisionSuccess from './push-provision-success/PushProvisionSuccess';

interface PermissionInformationProps {
    pushProvisionSuccess: boolean;
    permissionGiven: boolean;
    data: GooglePayTeData;
    handlePushProvisionSuccess: () => void;
    signResponse: DigitalWalletSignResponse | undefined;
    googleWalletInfo: GtpWalletInfoResult;
}

const PermissionInformation: React.FC<PermissionInformationProps> = ({
    data,
    pushProvisionSuccess,
    permissionGiven,
    handlePushProvisionSuccess,
    signResponse,
    googleWalletInfo,
}) => {
    const { googleWalletConfirmAddPermissionToGooglePayIConfirm, googleWalletConfirmAddPermissionToGooglePayIsAdded } =
        useText();

    // const cardNumber = data.source === 'kb' ? data.card.maskedCardNumber : data.card.number;
    const cardNumber = data.card.number;

    if (pushProvisionSuccess) {
        return <PushProvisionSuccess cardNumber={cardNumber} />;
    }

    if (permissionGiven) {
        return (
            <PermissionSigning
                card={data.card}
                handlePushProvisionSuccess={handlePushProvisionSuccess}
                signResponse={signResponse}
                googleWalletInfo={googleWalletInfo}
            />
        );
    }

    return (
        <div className="confirm-google-pay-activation-permission-modal__content">
            <p>
                <span>{`${googleWalletConfirmAddPermissionToGooglePayIConfirm} `}</span>
                <b>{Format.cardNumber(cardNumber)}</b>
                <span>{` ${googleWalletConfirmAddPermissionToGooglePayIsAdded}`}</span>
            </p>
        </div>
    );
};

export default PermissionInformation;
